<template>
  <div id="tutorialLoadingImage" v-if="isLoading">
    <!-- Placeholder image or loading indicator -->
    <img class="d-none d-md-block mb-4" style="opacity:0.6;"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/fourCardsPlaceholder.svg" alt="">
    <img class="d-md-none mb-4" style="opacity:0.6;"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/categoryPlacholderMobile.svg" alt="">
  </div>
  <div v-if="tutorials && tutorials.length"
    class="bg-white mb-4 px-5 py-1 rounded-corners-10 tutorial">
    <div class="d-flex justify-content-between">
      <div class="text-primary my-3">
        <h5 class="font-weight-bolder" style="font-size: x-large;">Tutorials</h5>
      </div>
    </div>

    <div>
      <div class="splide tutorialSplide newFeatureSlider" aria-label="Slider for tutorials">
        <div class="sands-article-vueslidercontainer splide__track">
          <div class="splide__list">
            <div class="splide__slide" v-for="(tutorial, i) in filtereCourses" :key="i">
              <div class="h-100 d-flex flex-column feature-detail-article-column feature-detail rounded">
                <a :href="constructCourseURL(tutorial)" class="cursorPointer">
                  <img v-if="tutorial.teaserImage && tutorial.teaserImage.xxx" :src="tutorial.teaserImage.xxx" alt=""
                    class="card-img fixed-aspect-ratio" />
                </a>
                <div class="pb-2 pt-2 px-2 text-dark">
                  <div class="mb-4">
                    <a :href="constructCourseURL(tutorial)" class="cursorPointer">
                      <h4 v-if="tutorial.name" class="mb-3 text-break text-dark" style="font-size: larger;">
                      {{ tutorial.name }}
                      </h4>
                    </a>
                    <div class="pl-0 d-flex flex-row flex-wrap mb-0 mt-auto">
                      <span>{{ tutorial.slogan }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';
import CONCORD_QUERIES from "../../services/concord_queries.js"
import helperFunction from "../../services/helperfunctions.js"
import axios_queries from '../../services/axios_queries.js';
import {
  watch
} from 'vue'
import useElementVisible from "../../services/elementVisibilityService.js";

export default {
  name: "categoryConference",
  props: {
    settingsPerm: Object,
  },
  data() {
    return {
      isLoading: true,
      tutorials: false,
      loadMorePossible: true,
      isDevMioActive: false,
      currentPage: 1,
      metaCount: 0,
      firstTimeInViewport: true,
      initialDataLoaded: false,
    }
  },
  created() {

    setTimeout(() => {
      this.box1Ref = document.getElementById('tutorialLoadingImage');

      if (this.box1Ref) {
        const isVisible = useElementVisible(this.box1Ref);
        if (isVisible && isVisible.value && isVisible.value == true) {
          this.firstTimeInViewport = false;
          this.loadInitialData();
        }

        watch(isVisible, (newValue) => {
          if (this.firstTimeInViewport && isVisible && newValue === true) {
            this.firstTimeInViewport = false;
            this.loadInitialData();
          }
        });
      }

      this.emitter.on('coursesProcessed', () => {
        this.firstTimeInViewport = false;
        this.loadInitialData();
      });
    }, 500);
  },

  methods: {

    loadInitialData() {
      if (!this.initialDataLoaded) {
        this.initialDataLoaded = true;
        let tutorialsLoadingParams = {
          page: 1,
          pagesize: 16,
          querystring: this.settingsPerm.cat,
          transientKey: this.settingsPerm.cat + '-cat-depending-tutorials-vue',
          query: "cat-depending-tutorials-vue",
          url: this.settingsPerm.ajaxUrl+'/wp-content/uploads/catpages/'+this.settingsPerm.cat+'-cat-depending-tutorials-vue.json'
        };
        axios_queries.loadPublicData(tutorialsLoadingParams).then((concordData) => {
          if (concordData && concordData != null && concordData != undefined && concordData != '') {
            if (concordData.advancedSearch && concordData.advancedSearch.highlights && concordData.advancedSearch.highlights.courses && concordData.advancedSearch.highlights.courses.Courses && concordData.advancedSearch.highlights.courses.Courses.length) {
              // this.displayTutorials(concordData.advancedSearch.highlights.courses.Courses);
            let filtereCourses = concordData.advancedSearch.highlights.courses.Courses.filter(event => {
                  return event.genre === 'TUTORIAL'
                })
                if (filtereCourses && filtereCourses.length >= 3) {
                  this.displayTutorials(filtereCourses);
                }else{
                  this.isLoading = false;
                  this.emitter.emit('TutotialsProcessed', true);
                }
              }else{
                this.isLoading = false;
                this.emitter.emit('TutotialsProcessed', true);
              }
            }else{
              this.isLoading = false;
              this.emitter.emit('TutotialsProcessed', true);
            }
        })
      }
    },

    displayTutorials(tutorials) {
      this.tutorials = tutorials;
      this.isLoading = false;
      this.mount_splide();
    },

    async loadMoreData() {
      // Make an API call to fetch more data
      const nextPage = this.currentPage + 1;
      let variablesForQuery = {
        page: nextPage,
        pagesize: 12,
        querystring: this.settingsPerm.cat,
      };
      let graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_HIGHLIGHT;
      let concordData = await axios_queries.getMoreData(graphqlQuery,variablesForQuery);
        if (concordData && concordData.advancedSearch && concordData.advancedSearch.highlights && concordData.advancedSearch.highlights.courses && concordData.advancedSearch.highlights.courses.Courses && concordData.advancedSearch.highlights.courses.Courses.length) {
          const newtutorials = concordData.advancedSearch.highlights.courses.Courses;
          let filteredEvents = newtutorials.filter(event => event.genre === 'TUTORIAL');
          // console.log('New tutorials',newtutorials);
          if (filteredEvents && filteredEvents.length) {
            this.events = [...this.events, ...filteredEvents];
          }
          // console.log('tutorials = new tutorials',this.tutorials);
          this.isLoading = false;
          this.currentPage = nextPage;
          this.mount_splide();
        }
    },

    constructCourseURL(slug) {
      return helperFunction.sandsConstructRealUrl(slug);
    },

    addMovedEventListener() {
      this.splide.on('moved', (newIndex) => {
        const lastCardIndex = newIndex + this.splide.options.perPage;
        // console.log('lastcardindex', lastCardIndex);
        // console.log('lenght', this.tutorials.length);

        if (lastCardIndex === this.tutorials.length - 2 && this.tutorials.length > this.metaCount) {
          this.loadMoreData();
        }
      });
    },

    mount_splide: function () {
      let thiz = this;
      setTimeout(function () {
        if (!thiz.splide) {
          thiz.splide = new Splide('.tutorialSplide', {
            classes: {
              prev: 'splide__arrow--prev xx',
              next: 'splide__arrow--next xxx',
              arrow: 'splide__arrow xxxx',
            },
            perPage: 4,
            perMove: 1,
            rewindByDrag: true,
            gap: '1rem',
            breakpoints: {
              1600: {
                perPage: 4,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              1200: {
                perPage: 3,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              991: {
                perPage: 2,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
              767: {
                perPage: 1,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
            },
            rewind: false,
            pagination: false,
            padding: {
              right: '0rem',
              left: '0rem',
            }
          });
          thiz.splide.mount();
          thiz.addMovedEventListener(); // Add event listener
        } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
        }
      }, 100);
    },

  },



  computed: {
    filtereCourses() {
      if (this.tutorials) {
        // Filter the tutorials by genre "TUTORIAL"
        return this.tutorials.filter(tutorial => tutorial.genre === 'TUTORIAL');
      }
      return [];
    },
  },
};
</script>